import { FC, ReactNode, MouseEvent, useState } from 'react'
import { IconButton } from '@mui/material'

/* Utils */
import { useAppDispatch } from '../../../../../store/hooks'
import { notification } from '../../../../../store/notifications/notificationSlice'
import { FILE_NAME } from './crowdstrikeIntegration.constants'

/* Components */
import {
  CrowdstrikeInstructionsTitle,
  CrowdstrikeInstructionsWrapper,
  CrowdstrikeInstructionsContent,
  CrowdstrikeInstructionsTitleWrapper
} from './crowdstrikeIntegration.styles'
import CrowdstrikeInstructionsTooltip from './CrowdstrikeInstructionsTooltip'
import { IntegrationInfoIcon } from '../../../svg'

interface Props {
  content: ReactNode
}

const CrowdstrikeInstructions: FC<Props> = ({ content }) => {
  const dispatch = useAppDispatch()
  const [clientAnchor, setClientAnchor] = useState<null | HTMLElement>(null)
  const [clientOpen, setClientOpen] = useState(false)

  const clientCanBeOpen = clientOpen && Boolean(clientAnchor)
  const clientId = clientCanBeOpen ? 'transition-popper' : undefined

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setClientAnchor(e.currentTarget)
    setClientOpen(!clientOpen)
  }

  const handleDownload = () => {
    fetch('/crowdstrikeIntegration.pdf').then((response) => {
      response
        .blob()
        .then((blob) => {
          const fileURL = window.URL.createObjectURL(blob)
          const alink = document.createElement('a')
          alink.href = fileURL
          alink.download = FILE_NAME
          alink.click()
        })
        .then(() => {
          dispatch(
            notification({
              open: true,
              variant: 'success',
              message: 'PDF saved to desktop'
            })
          )
        })
        .catch(() => {
          dispatch(
            notification({
              open: true,
              variant: 'error',
              message: 'Failed saving PDF to desktop'
            })
          )
        })
    })
  }

  return (
    <CrowdstrikeInstructionsWrapper>
      <CrowdstrikeInstructionsTitleWrapper>
        <CrowdstrikeInstructionsTitle>Instructions</CrowdstrikeInstructionsTitle>
        <IconButton onClick={handleClick}>
          <IntegrationInfoIcon />
        </IconButton>
        <CrowdstrikeInstructionsTooltip
          id={clientId}
          open={clientOpen}
          anchorEl={clientAnchor}
          handleDownload={handleDownload}
          handleClickAway={() => {
            if (clientOpen) {
              setClientOpen(false)
            }
          }}
        />
      </CrowdstrikeInstructionsTitleWrapper>
      <CrowdstrikeInstructionsContent>{content}</CrowdstrikeInstructionsContent>
    </CrowdstrikeInstructionsWrapper>
  )
}

export default CrowdstrikeInstructions
